import { api } from '@services';

import Document, { IDocument, IDocumentApiModel } from '@models/Document.model';

interface IRequest {
  equipmentId: string;
}

const getEquipmentDocuments = async ({
  equipmentId,
}: IRequest): Promise<IDocument[]> => {
  const { data: documents } = await api.get<IDocumentApiModel[]>(
    `/equipments/${equipmentId}/documents`,
  );

  return Document.arrayFromApiModel(documents);
};

export { getEquipmentDocuments };
